import React, { useState, useRef, useCallback, useEffect } from 'react';
import { motion, useMotionValue, useTransform, useAnimation } from 'framer-motion';
import { RefreshCw } from 'lucide-react';

const PullToRefresh = ({ children, onRefresh, threshold = 80 }) => {
  // Temporarily disable pull-to-refresh to fix scrolling issues
  // Just return the children wrapped in a div for now
  return (
    <div className="relative">
      {children}
    </div>
  );
};

export default PullToRefresh;